import { render, staticRenderFns } from "./Google2saSettings.vue?vue&type=template&id=57185fb6&scoped=true&"
import script from "./Google2saSettings.vue?vue&type=script&lang=js&"
export * from "./Google2saSettings.vue?vue&type=script&lang=js&"
import style0 from "./Google2saSettings.vue?vue&type=style&index=0&id=57185fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57185fb6",
  null
  
)

export default component.exports